import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Map, TileLayer, Circle } from "react-leaflet";
import { putData, getData } from "../../../Core/Projects/action";
import { getLocation } from "../../../Core/Location/action";
import { getPackages } from "../../../Core/Packages/action";
import { getSinglePhotographer } from "../../../Core/SinglePhotographer/action";
import { changeData, unchangeData } from "../../../Core/ChangeValues/action";
import { getActiveCities } from "../../../Core/Location/ActiveCities/action";
import { getActiveLocationOptions } from "../../../Core/Location/CheckActiveOptions/action";
import { getMylocations } from "../../../Core/MyLocations/action";
import {
  PinIcon,
  PinIconActive,
  StudioIcon,
  StudioOutIcon,
  ParkIcon,
  ParkCostIcon,
} from "./LocationIcon";
import Markers from "./Markers";
import MyLocations from "./Mylocations";
import Loader from "../../Loader";
import "leaflet/dist/leaflet.css";
import styles from "../../../Assets/Styles/Components/Book/Map/MapView.module.css";

import inLocation from "../../../Assets/Images/Components/Book/Map/in-location.svg";
import inStudio from "../../../Assets/Images/Components/Book/Map/studio.svg";
import inOutSide from "../../../Assets/Images/Components/Book/Map/out-side.svg";
import nextArrow from "../../../Assets/Images/Components/Book/Map/next-step.png";
import lastLocs from "../../../Assets/Images/Components/Book/Map/last-locs.svg";

import { studios } from "../../../Constants/map";
import baseUrl from "../../../Core/url";

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      currentLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      zoom: 11,
      centerMap: { lat: "35.6995454251", lng: "51.395642622465" },
      activeLocationType: 0,
      searchItems: [],
      isAddress: false,
      address_detail: null,
      address_latitude: null,
      address_longitude: null,
      locationTypes: false,
      isSearching: false,
      selectedCityName: "",
      skip_location: false,
      skip_start_time: false,
      // typing: false,
      typingTimeout: 0,
      isAddressError: false,
      onDraging: false,
      gotoPhotographerCity: false,
      //  New Changes
      citySelected: "",
      citySelectedLat: "35.6995454251",
      citySelectedLong: "51.395642622465",
      citySelectedId: 0,
      //  Self Location
      selfLat: "35.6995454251",
      selfLng: "51.395642622465",
      //  Suggested Locaton
      suggestLat: "35.6995454251",
      suggestLng: "51.395642622465",
      //  New locations
      initialSelfLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      modifiedSelfLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      initialAtliyehLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      modifiedAtliyehLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      initialSuggestLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      modifiedSuggestLocation: { lat: "35.6995454251", lng: "51.395642622465" },
      selectedLocationType: 0,
      mapHeight: 400,
      showMyLocations: false,
    };
    this.changeInputValue = this.changeInputValue.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.props.getActiveCities();
    if (!this.props.project.slug) {
      if (window.location.search && window.location.search.substr(1)) {
        this.props.getData(
          Object.fromEntries(
            new URLSearchParams(window.location.search.substring(1))
          ).slug,
          {}
        );
      }
      // this.props.getLocation();
    }
    if (
      (this.props.project.slug &&
        this.props.locations &&
        Object.keys(this.props.locations.location).length === 0) ||
      (this.props.project.slug && this.props.change)
    ) {
      this.props.getLocation(this.props.project.data.shoot_type_id);
      this.props.unchangeData();
    }
    if (this.props.project.slug && this.props.project.data?.address_latitude) {
      const {
        address_latitude,
        address_longitude,
        search_for_studio,
        address_detail,
        skip_location,
      } = this.props.project.data;
      const location = { lat: address_latitude, lng: address_longitude };
      this.setState({
        address_latitude,
        address_longitude,
        address_detail,
        currentLocation: location,
        centerMap: location,
        skip_location,
      });
      search_for_studio && this.setState({ activeLocationType: 2 });
    }
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
    this.props.getMylocations();
  }

  componentDidUpdate(preProps) {
    if (
      (this.props.project &&
        this.props.project.data &&
        preProps.project.data.step !== this.props.project.data.step) ||
      (this.props.project &&
        !this.props.project.loading &&
        preProps.project.loading !== this.props.project.loading)
    ) {
      this.props.history.push(
        `/book/${this.props.project.data.step}?slug=${this.props.project.slug}`
      );
    }
    if (
      this.props.project?.data?.shoot_type_id &&
      this.props.locations?.location &&
      !this.props.locations.loading &&
      Object.keys(this.props.locations.location).length === 0
    ) {
      this.props.getLocation(this.props.project.data.shoot_type_id);
      this.setValues();
    }
    if (
      this.props.project &&
      this.props.project.data &&
      !this.props.project.loading &&
      this.props.project.data.photographer_uid &&
      this.props.project.data.direct_photographer &&
      this.props.sphotographer &&
      !this.props.sphotographer.loading &&
      Object.keys(this.props.sphotographer.sphotographer).length === 0
    ) {
      this.props.getSinglePhotographer(
        this.props.project.data.photographer_uid
      );
    }
    if (
      this.props.locations &&
      this.props.locations.location &&
      !this.props.locations.loading &&
      this.props.project &&
      this.props.project.data &&
      this.props.project.data.photographer_uid &&
      this.props.project.data.direct_photographer &&
      this.props.sphotographer &&
      !this.props.sphotographer.loading &&
      Object.keys(this.props.sphotographer.sphotographer).length !== 0 &&
      !this.state.gotoPhotographerCity &&
      !this.props.project.data.address_latitude
    ) {
      this.gotoPCity();
    }

    if (
      this.props.project &&
      this.props.project.data &&
      !this.props.project.loading &&
      this.props.project.data.city_name &&
      this.props?.activeCities &&
      this.props?.activeCities?.activeCities?.length !== 0 &&
      !this.props.activeCities.loading &&
      this.state.citySelected === ""
    ) {
      this.selectCity(
        { target: { value: this.props.project.data.city_name } },
        this.state.selectedLocationType
      );
    }
    if (
      this.props.project &&
      this.props.project.data &&
      !this.props.project.loading &&
      this.props.project.data.city_name &&
      this.props?.activeCities &&
      this.props?.activeCities?.activeCities?.length !== 0 &&
      !this.props.activeCities.loading &&
      this.state.citySelected !== "" &&
      this.state.selectedLocationType === 0 &&
      this.state.activeLocationType === 0
    ) {
      this.setNewValues();
      // this.selectCity({ target: { value: this.props.project.data.city_name } }, null);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("height", this.updateDimensions);
  }

  setNewValues = () => {
    const {
      address_detail,
      address_latitude,
      address_longitude,
      search_for_studio,
      shoot_location_slug,
      skip_location,
    } = this.props.project.data;
    if (
      !search_for_studio &&
      !shoot_location_slug &&
      address_detail &&
      address_latitude
    ) {
      this.setState({
        address_detail,
        skip_location,
        initialSelfLocation: { lat: address_latitude, lng: address_longitude },
        modifiedSelfLocation: { lat: address_latitude, lng: address_longitude },
        selectedLocationType: 1,
      });
    }
    if (search_for_studio && !shoot_location_slug) {
      this.setState({
        initialAtliyehLocation: {
          lat: address_latitude,
          lng: address_longitude,
        },
        modifiedAtliyehLocation: {
          lat: address_latitude,
          lng: address_longitude,
        },
        selectedLocationType: 2,
        skip_location,
      });
    }
    if (!search_for_studio && shoot_location_slug) {
      this.setState({
        initialSuggestLocation: {
          lat: address_latitude,
          lng: address_longitude,
        },
        modifiedSuggestLocation: {
          lat: address_latitude,
          lng: address_longitude,
        },
        selectedLocationType: 3,
        skip_location,
      });
    }
  };

  setValues = () => {
    const {
      address_latitude,
      address_longitude,
      search_for_studio,
      address_detail,
      skip_location,
      skip_start_time,
    } = this.props.project.data;
    const location = {};
    if (address_latitude) {
      location.lat = address_latitude;
      location.lng = address_longitude;
    } else {
      location.lat = "35.6995454251";
      location.lng = "51.395642622465";
    }
    this.setState({
      address_latitude,
      address_longitude,
      address_detail,
      initialSelfLocation: location,
      modifiedSelfLocation: location,
      initialSuggestLocation: location,
      modifiedSuggestLocation: location,
      skip_location,
      skip_start_time,
    });
    // search_for_studio ? this.setState({ activeLocationType: 2 }) : this.setState({ activeLocationType: 1 });
  };

  getNewLocation(term, lat, lng) {
    this.setState({ isSearching: true });
    fetch(
      `https://api.neshan.org/v1/search?term=${term}&lat=${lat}&lng=${lng}`,
      {
        method: "GET",
        headers: {
          "Api-Key": "service.INXCdRnCoqxNa3Pt1dAzcHrnJucOEwSBuItxnraW",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const res = data.items;
        const region = res.filter((a) => {
          return a.category === "region";
        });
        const municipal = res.filter((a) => {
          return a.category === "municipal";
        });
        const place = res.filter((a) => {
          return a.category === "place";
        });
        const others = res.filter((a) => {
          return (
            a.category !== "region" &&
            a.category !== "municipal" &&
            a.category !== "place"
          );
        });
        const park = place.filter((a) => {
          return a.type === "park";
        });
        const museum = place.filter((a) => {
          return a.type === "museum";
        });
        const store = place.filter((a) => {
          return a.type === "store";
        });
        const shopping_mall = place.filter((a) => {
          return a.type === "shopping_mall";
        });
        const otherPlaces = place.filter((a) => {
          return (
            a.type !== "park" &&
            a.type !== "museum" &&
            a.type !== "store" &&
            a.type !== "shopping_mall"
          );
        });
        this.setState({
          searchItems: [
            ...region,
            ...municipal,
            ...park,
            ...museum,
            ...store,
            ...shopping_mall,
            ...otherPlaces,
            ...others,
          ],
        });
        this.setState({ isSearching: false });
      })
      .catch((error) => {
        this.setState({ isSearching: false });
      });
  }

  changeInputValue = (event) => {
    const {
      centerMap,
      selfLat,
      selfLng,
      activeLocationType,
      citySelectedLat,
      citySelectedLong,
    } = this.state;
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    if (event.target.value === "") {
      this.setState({ searchItems: [], inputValue: "" });
    }
    if (event.target.value !== "") {
      this.setState({
        inputValue: event.target.value,
        typingTimeout: setTimeout(() => {
          this.getNewLocation(
            this.state.inputValue,
            activeLocationType === 1 ? selfLat : citySelectedLat,
            activeLocationType === 1 ? selfLng : citySelectedLong
          );
        }, 1000),
      });
    }
  };

  changeTextValue = (event) => {
    this.setState({ address_detail: event.target.value });
  };

  changeLocationType = (id) => () => {
    const { project, sphotographer } = this.props;
    if (
      (project.data.direct_photographer &&
        sphotographer.sphotographer.has_studio) ||
      !project.data.direct_photographer
    ) {
      if (id === 2) {
        this.setState({ activeLocationType: id });
      }
    }
    if (id !== 2) {
      this.setState({
        activeLocationType: id,
        currentLocation: this.state.centerMap,
      });
    }
  };

  changeSelectedCity = (city) => () => {
    const location = { lat: city.latitude, lng: city.longitude };
    this.setState({ currentLocation: location, centerMap: location });
  };

  returnLocation = () => () => {
    const data = {
      address_latitude: this.state.currentLocation.lat,
      address_longitude: this.state.currentLocation.lng,
    };
    const { sphotographer } = this.props.sphotographer;
    this.state.activeLocationType === 2
      ? (data.search_for_studio = true)
      : (data.search_for_studio = false);
    if (
      this.state.activeLocationType === 2 &&
      !this.props.project.data.direct_photographer
    ) {
      this.setState({
        address_detail: null,
        address_latitude: this.state.centerMap.lat,
        address_longitude: this.state.centerMap.lng,
      });
      setTimeout(() => {
        this.goNextStep();
      }, 50);
    }
    if (
      this.state.activeLocationType === 2 &&
      this.props.project.data.direct_photographer &&
      sphotographer.has_studio
    ) {
      this.setState({
        address_detail: `آتلیه ${sphotographer.abbrv_name}`,
        address_latitude: sphotographer.studio_lat,
        address_longitude: sphotographer.studio_lng,
      });
      setTimeout(() => {
        this.goNextStep();
      }, 50);
    }
    if (this.state.activeLocationType === 1) {
      this.setState({
        isAddress: true,
        address_latitude: this.state.centerMap.lat,
        address_longitude: this.state.centerMap.lng,
      });
    }
  };

  goSearchedCity = (item) => () => {
    const location = { lat: item.location.y, lng: item.location.x };
    this.setState({
      currentLocation: location,
      centerMap: location,
      searchItems: [],
      inputValue: item.title,
    });
    this.setState({
      currentLocation: location,
      centerMap: location,
      searchItems: [],
      inputValue: item.title,
    });
  };

  goSearchedCitySelf = (item) => () => {
    const location = { lat: item.location.y, lng: item.location.x };
    this.setState({
      initialSelfLocation: location,
      searchItems: [],
      inputValue: item.title,
      zoom: 15,
    });
  };

  goSearchedCityLocations = (item) => () => {
    const location = { lat: item.location.y, lng: item.location.x };
    this.setState({
      initialSuggestLocation: location,
      searchItems: [],
      inputValue: item.title,
      zoom: 15,
    });
  };

  selectCitySearched = (city) => {
    const location = { lat: city.latitude, lng: city.longitude };
    this.setState({ currentLocation: location, centerMap: location });
  };

  closeAddressBox = () => {
    this.setState({ isAddress: false });
  };

  goNextStep = () => {
    const {
      address_latitude,
      address_longitude,
      address_detail,
      skip_location,
      skip_start_time,
    } = this.state;
    const {
      modifiedSelfLocation,
      modifiedAtliyehLocation,
      activeLocationType,
    } = this.state;
    const { slug, data } = this.props.project;
    const exData = { address_detail, address_latitude, address_longitude };
    activeLocationType === 2
      ? (exData.search_for_studio = true)
      : (exData.search_for_studio = false);
    const { sphotographer } = this.props.sphotographer;
    if (this.state.skip_location) {
      this.props.getPackages();
      this.props.putData(
        slug,
        {
          ...data,
          address_detail,
          search_for_studio: false,
          address_latitude,
          address_longitude,
          skip_location,
          step: this.props.history.location.pathname.slice(1).split("/")[1],
        },
        this.props.sphotographer
      );
      return;
    }
    if (this.state.showMyLocations) {
      this.props.getPackages();
      this.props.putData(
        slug,
        {
          ...data,
          address_detail,
          search_for_studio: false,
          address_latitude,
          address_longitude,
          skip_location,
          step: this.props.history.location.pathname.slice(1).split("/")[1],
        },
        this.props.sphotographer
      );
      return;
    }
    if (
      activeLocationType === 1 &&
      (!address_detail || address_detail === "" || address_detail.trim() === "")
    ) {
      this.props.getPackages();
      this.setState({ isAddressError: true });
    } else {
      this.setState({ isAddressError: false });
      if (activeLocationType === 1) {
        this.props.getPackages();
        this.props.putData(
          slug,
          {
            ...data,
            address_detail,
            search_for_studio: false,
            address_latitude: modifiedSelfLocation.lat,
            address_longitude: modifiedSelfLocation.lng,
            skip_location,
            step: this.props.history.location.pathname.slice(1).split("/")[1],
          },
          this.props.sphotographer
        );
      }
      if (activeLocationType === 2) {
        this.props.getPackages();
        if (sphotographer?.has_studio) {
          this.props.putData(
            slug,
            {
              ...data,
              search_for_studio: true,
              address_latitude: sphotographer.studio_lat,
              address_longitude: sphotographer.studio_lng,
              skip_location,
              step: this.props.history.location.pathname.slice(1).split("/")[1],
            },
            this.props.sphotographer
          );
        } else {
          this.props.putData(
            slug,
            {
              ...data,
              search_for_studio: true,
              address_latitude: modifiedAtliyehLocation.lat,
              address_longitude: modifiedAtliyehLocation.lng,
              skip_location,
              step: this.props.history.location.pathname.slice(1).split("/")[1],
            },
            this.props.sphotographer
          );
        }
      }
      // this.props.putData(slug, { ...data, ...exData, step: this.props.history.location.pathname.slice(1).split('/')[1] });
      // this.props.changeData();
    }
  };

  gotoPCity = () => {
    this.setState({ gotoPhotographerCity: true });
    const city = this.props.locations.location.cities.find(
      (item) => item.name === this.props.sphotographer.sphotographer.city_name
    );
    const location = { lat: city.latitude, lng: city.longitude };
    this.setState({
      currentLocation: location,
      centerMap: location,
      inputValue: "",
      selectedCityName: "",
    });
  };

  selectCity = (c, t) => {
    const { activeCities, project } = this.props;
    const s = activeCities.activeCities.filter(
      (i) => i.name === c.target.value
    );
    this.setState({
      citySelected: s[0].name,
      citySelectedId: s[0].id,
      citySelectedLat: s[0].latitude,
      citySelectedLong: s[0].longitude,
      selfLat: s[0].latitude,
      selfLng: s[0].longitude,
      suggestLat: s[0].latitude,
      suggestLng: s[0].longitude,
      initialSelfLocation: { lat: s[0].latitude, lng: s[0].longitude },
      modifiedSelfLocation: { lat: s[0].latitude, lng: s[0].longitude },
      initialAtliyehLocation: { lat: s[0].latitude, lng: s[0].longitude },
      modifiedAtliyehLocation: { lat: s[0].latitude, lng: s[0].longitude },
      initialSuggestLocation: { lat: s[0].latitude, lng: s[0].longitude },
      modifiedSuggestLocation: { lat: s[0].latitude, lng: s[0].longitude },
      activeLocationType: 0,
      selectedLocationType: t,
      selectedCityName: s[0].name,
    });
    this.props.getActiveLocationOptions(project.slug, s[0].id);
    const token = localStorage.getItem("token");
    fetch(`${baseUrl}/projects/${project.slug}/set_city_name`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ city_name: c.target.value }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.log("error", error);
      });
  };

  changeSelfLocation = () => {
    console.log(`saeed`);
  };

  hideImber = (n) => {
    const imber = document.getElementById("root_raychat");
    if (window.innerWidth >= 768) {
      // imber.classList.remove(`${styles.imberDeactive}`);
    }
    if (n !== 0 && window.innerWidth < 768) {
      // imber.classList.add(`${styles.imberDeactive}`);
    }
    if (n === 0 && window.innerWidth < 768) {
      // imber.classList.remove(`${styles.imberDeactive}`);
    }
  };

  changeoptionSelectedCity(name) {
    const city = this.props.locations.location.cities.find(
      (item) => item.name === name
    );
    const location = { lat: city.latitude, lng: city.longitude };
    this.setState({
      currentLocation: location,
      centerMap: location,
      inputValue: "",
      selectedCityName: name,
    });
  }

  updateDimensions() {
    if (window.innerWidth < 768) {
      this.setState({ mapHeight: window.innerHeight });
    }
  }

  render() {
    const {
      currentLocation,
      zoom,
      searchItems,
      isAddress,
      address_detail,
      inputValue,
      isSearching,
      activeLocationType,
      centerMap,
      isAddressError,
      onDraging,
      selectedCityName,
      citySelected,
      citySelectedId,
      citySelectedLat,
      citySelectedLong,
      selfLat,
      selfLng,
      suggestLat,
      suggestLng,
    } = this.state;
    const {
      initialSelfLocation,
      modifiedSelfLocation,
      initialSuggestLocation,
      modifiedSuggestLocation,
    } = this.state;
    const { cities, shoot_locations } = this.props.locations.location;
    const { sphotographer } = this.props.sphotographer;
    const { project, activeCities, activeLocationOptions } = this.props;
    const { selectedLocationType } = this.state;

    return (
      <div className="container">
        <MyLocations
          show={this.state.showMyLocations}
          addresses={this.props?.mylocations?.mylocations}
          onClose={(_) => {
            this.setState({ showMyLocations: false });
          }}
          onSave={(address) => {
            this.setState((prevState) => ({
              address_latitude: address.lat,
              address_longitude: address.long,
              address_detail: address.detail,
            }));
            setTimeout(() => {
              this.goNextStep();
            }, 50);
          }}
        />
        <div className="row">
          <div className="col-12">
            {/* PopUp */}
            <div
              className={` ${styles.addressContainer} ${
                isAddress ? styles.addressContainerActive : ""
              } `}
              onClick={this.closeAddressBox}
            >
              <div
                className="cotainer"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className={` ${styles.addressBox}`}>
                  <h4>درج آدرس دقیق</h4>
                  <div
                    className={styles.closeBtn}
                    onClick={this.closeAddressBox}
                  >
                    &#215;
                  </div>
                  <textarea
                    value={address_detail}
                    onChange={this.changeTextValue}
                    name=""
                    id=""
                    rows="7"
                    placeholder="لطفا آدرس دقیق خود را وارد کنید"
                    className={`col-12 ${
                      isAddressError ? styles.errorBorder : ""
                    }`}
                  />
                  {isAddressError && (
                    <div className={styles.error}>
                      لطفا آدرس خود را وارد کنید!
                    </div>
                  )}
                  <div
                    className={`col-12 align-items-center justify-content-center ${styles.btnNextStep}`}
                    onClick={this.goNextStep}
                  >
                    ثبت آدرس
                    <i
                      className="fa fa-arrow-left"
                      aria-hidden="true"
                      style={{ marginRight: "5px" }}
                    >
                      {" "}
                    </i>
                  </div>
                </div>
              </div>
            </div>
            <div className="custom-box">
              <div className={styles.mapViewContainer}>
                <div className={styles.btns}>
                  <h4 style={{ paddingBottom: "0.5em", color: "#2f2f2f", textAlign: "center" }}>کجا میخواهید عکاسی یا فیلمبرداری کنید؟</h4>
                  {activeCities?.loading ? (
                    <Loader scale={1} />
                  ) : (
                    <>
                      <select
                        name="activeCities"
                        className={`${styles.inputCenter}`}
                        value={citySelected}
                        onChange={(e) => this.selectCity(e, null)}
                        required
                      >
                        <option disabled defaultValue="" value="">
                          {" "}
                          -- ابتدا شهر مورد نظر خود را انتخاب کنید --{" "}
                        </option>
                        {activeCities?.activeCities?.length !== 0 &&
                          activeCities.activeCities.map((ac) => {
                            return (
                              <option
                                data-lat={ac.latitude}
                                data-long={ac.longitude}
                                data-id={ac.id}
                                key={ac.id}
                                value={ac.name}
                              >
                                {ac.name}
                              </option>
                            );
                          })}
                      </select>
                      <button
                        onClick={() => {
                          this.setState({
                            skip_location: true,
                            search_for_studio: false,
                            shoot_location_slug: null,
                          });
                          setTimeout(() => {
                            this.goNextStep();
                          }, 150);
                        }}
                        className={`${styles.btn}  ${
                          this.state.skip_location
                            ? styles.btnBeforeSelected
                            : ""
                        } ${styles.hoverAnimation}`}
                        type="button"
                        disabled={
                          activeCities?.activeCities?.length !== 0 &&
                          !activeLocationOptions?.activeLocationOptions
                            ?.inLocation
                            ? "disabled"
                            : ""
                        }
                      >
                        <div className={styles.btnContent}>
                          <div className={styles.btnImg}>
                            <img src={nextArrow} alt="out-side" />
                          </div>
                          <div className={styles.btnTexts} style={{ display: "flex", alignItems: "center" }}>
                            <div className={styles.btnTexts} style={{ display: "inline-block" }}>
                              <h4>مشخص نیست</h4>
                              <p>مشورت با متخصص برای تعیین مکان</p>
                            </div>
                            <div className={styles.btnTexts} style={{ display: "inline-block", textAlign: "left" }}>
                              <button type="button" className={styles.goNext}>انتخاب</button>
                              <i className="fa fa-arrow-left" aria-hidden="true" style={{ marginLeft: "5px" }}>{" "}</i>
                            </div>
                          </div>
                        </div>
                      </button>
                      <button
                        onClick={() => {
                          this.setState({
                            activeLocationType: 1,
                            selectedLocationType: 0,
                            skip_location: false,
                          });
                          this.hideImber(1);
                        }}
                        className={`${styles.btn} ${
                          activeLocationType === 1 ? styles.btnSelected : ""
                        } ${
                          selectedLocationType === 1 &&
                          !this.state.skip_location
                            ? styles.btnBeforeSelected
                            : ""
                        }`}
                        type="button"
                        disabled={
                          activeCities?.activeCities?.length !== 0 &&
                          !activeLocationOptions?.activeLocationOptions
                            ?.inLocation
                            ? "disabled"
                            : ""
                        }
                      >
                        <div className={styles.btnContent}>
                          <div className={styles.btnImg}>
                            <img src={inLocation} alt="my-location" />
                          </div>
                          {activeLocationOptions?.loading ? (
                            <Loader scale={1} />
                          ) : (
                            <div className={styles.btnTexts} style={{ display: "flex", alignItems: "center" }}>
                              <div className={styles.btnTexts} style={{ display: "inline-block" }}>
                                <h4>در محل</h4>
                                <p>ثبت آدرس جدید روی نقشه</p>
                              </div>
                              <div className={styles.btnTexts} style={{ display: "inline-block", textAlign: "left" }}>
                                <button type="button" className={styles.goNext}>انتخاب</button>
                                <i
                                  className="fa fa-arrow-left"
                                  aria-hidden="true"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {" "}
                                </i>
                              </div>
                            </div>
                          )}
                        </div>
                      </button>
                      <button
                        onClick={() => {
                          sphotographer?.has_studio
                            ? null
                            : setTimeout(() => {
                                this.goNextStep();
                              }, 150);
                          this.setState({
                            activeLocationType: 2,
                            selectedLocationType: 0,
                            skip_location: false,
                          });
                        }}
                        className={`${styles.btn} ${
                          activeLocationType === 2 ? styles.btnSelected : ""
                        }  ${
                          selectedLocationType === 2
                            ? styles.btnBeforeSelected
                            : ""
                        } `}
                        type="button"
                        disabled={
                          activeCities?.activeCities?.length !== 0 &&
                          !activeLocationOptions?.activeLocationOptions
                            ?.inStudio
                            ? "disabled"
                            : ""
                        }
                      >
                        <div className={styles.btnContent}>
                          <div className={styles.btnImg}>
                            <img src={inStudio} alt="studio" />
                          </div>
                          {activeLocationOptions?.loading ? (
                            <Loader scale={1} />
                          ) : (
                            <div className={styles.btnTexts} style={{ display: "flex", alignItems: "center" }}>
                              <div className={styles.btnTexts} style={{ display: "inline-block" }}>
                                <h4>در آتلیه </h4>
                                {!sphotographer?.city_name ? (
                                  selectedCityName.length !== 0 ? (
                                    activeCities?.activeCities?.length !== 0 &&
                                    activeLocationOptions?.activeLocationOptions
                                      ?.inStudio ? (
                                      <p>
                                        {" "}
                                        عکاسی در آتلیه های {" "}
                                        {selectedCityName}
                                      </p>
                                    ) : (
                                      <p>
                                        کادرو در {selectedCityName} آتلیه ندارد
                                      </p>
                                    )
                                  ) : (
                                    <p>ابتدا شهر مورد نظر خود را انتخاب کنید</p>
                                  )
                                ) : selectedCityName.length !== 0 ? (
                                  activeLocationOptions?.activeLocationOptions
                                    ?.inStudio ? (
                                    <p>
                                      آتلیه {sphotographer.abbrv_name} در{" "}
                                      {selectedCityName}
                                    </p>
                                  ) : sphotographer.has_studio ? (
                                    <p>
                                      {sphotographer.abbrv_name} در{" "}
                                      {selectedCityName} آتلیه ندارد
                                    </p>
                                  ) : (
                                    <p>{sphotographer.abbrv_name} آتلیه ندارد</p>
                                  )
                                ) : (
                                  <p>ابتدا شهر مورد نظر خود را انتخاب کنید</p>
                                )}
                              </div>
                              <div className={styles.btnTexts} style={{ display: "inline-block", textAlign: "left" }}>
                                <button type="button" className={styles.goNext}>انتخاب</button>
                                <i
                                  className="fa fa-arrow-left"
                                  aria-hidden="true"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {" "}
                                </i>
                              </div>
                            </div>
                          )}
                        </div>
                      </button>
                      <button
                        onClick={() => {
                          this.setState({
                            activeLocationType: 3,
                            selectedLocationType: 0,
                            skip_location: false,
                          });
                          this.hideImber(3);
                        }}
                        className={`${styles.btn} ${
                          activeLocationType === 3 ? styles.btnSelected : ""
                        }  ${
                          selectedLocationType === 3
                            ? styles.btnBeforeSelected
                            : ""
                        }`}
                        type="button"
                        disabled={
                          activeCities?.activeCities?.length !== 0 &&
                          !activeLocationOptions?.activeLocationOptions
                            ?.inShootLocation
                            ? "disabled"
                            : ""
                        }
                      >
                        <div className={styles.btnContent}>
                          <div className={styles.btnImg}>
                            <img src={inOutSide} alt="out-side" />
                          </div>
                          {activeLocationOptions?.loading ? (
                            <Loader scale={1} />
                          ) : (
                            <div className={styles.btnTexts} style={{ display: "flex", alignItems: "center" }}>
                              <div className={styles.btnTexts} style={{ display: "inline-block" }}>
                                <h4> فضای باز، باغ ...</h4>
                                {selectedCityName.length !== 0 ? (
                                  activeCities?.activeCities?.length !== 0 &&
                                  activeLocationOptions?.activeLocationOptions
                                    ?.inShootLocation ? (
                                    <p>
                                      مکان های مناسب عکاسی در {selectedCityName}
                                    </p>
                                  ) : (
                                    <p>
                                      کادرو در {selectedCityName} مکان پیشنهادی
                                      ندارد
                                    </p>
                                  )
                                ) : (
                                  <p>ابتدا شهر مورد نظر خود را انتخاب کنید</p>
                                )}
                              </div>
                              <div className={styles.btnTexts} style={{ display: "inline-block", textAlign: "left" }}>
                                <button type="button" className={styles.goNext}>انتخاب</button>
                                <i
                                  className="fa fa-arrow-left"
                                  aria-hidden="true"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {" "}
                                </i>
                              </div>
                            </div>
                          )}
                        </div>
                      </button>
                    </>
                  )}
                  {this.props?.mylocations?.mylocations?.length > 0 && (
                    <button
                      type="button"
                      disabled={
                        activeCities?.activeCities?.length !== 0 &&
                        !activeLocationOptions?.activeLocationOptions
                          ?.addressHistory
                          ? "disabled"
                          : ""
                      }
                      onClick={() => {
                        this.setState({
                          showMyLocations: true,
                          activeLocationType: 0,
                        });
                      }}
                      className={`${styles.btn} `}
                    >
                      <div className={styles.btnContent}>
                        <div className={styles.btnImg}>
                          <img src={lastLocs} alt="lastLocs" />
                        </div>
                        <div className={styles.btnTexts} style={{ display: "flex", alignItems: "center" }}>
                          <div className={styles.btnTexts} style={{ display: "inline-block" }}>
                            <h4>آدرس‌های قبلی</h4>
                            <p>محل‌هایی که قبلا انتخاب کرده‌اید</p>
                          </div>
                          <div className={styles.btnTexts} style={{ display: "inline-block", textAlign: "left" }}>
                            <button type="button" className={styles.goNext}>انتخاب</button>
                            <i className="fa fa-arrow-left" aria-hidden="true" style={{ marginLeft: "5px" }}>
                              {" "}
                            </i>
                          </div>
                        </div>
                      </div>
                    </button>
                  )}
                </div>
                <div
                  style={{ height: `${this.state.mapHeight}px` }}
                  className={`${styles.map} ${
                    activeLocationType !== 0
                      ? activeLocationType === 2 && !sphotographer.has_studio
                        ? styles.mapHidden
                        : styles.mapShow
                      : styles.mapHidden
                  } `}
                >
                  {/* {activeCities?.activeCities?.length !== 0 && activeLocationType === 0 && <h3>لطفا گزینه مورد نظر خود را انتخاب کنید</h3>} */}
                  {activeCities?.activeCities?.length !== 0 &&
                    activeLocationType === 1 && (
                      <Map
                        style={{
                          width: "100%",
                          height: `${this.state.mapHeight}px`,
                        }}
                        // style={{ height: "50vh" }}
                        className={styles.heighter}
                        center={initialSelfLocation}
                        zoom={zoom}
                        ondrag={(event) => {
                          this.setState({
                            modifiedSelfLocation: event.target.getCenter(),
                          });
                        }}
                        maxZoom={18}
                        onDragStart={() => {
                          this.setState({ onDraging: true });
                        }}
                        onDragEnd={() => {
                          this.setState({ onDraging: false });
                        }}
                        onZoom={(event) => {
                          this.setState({
                            modifiedSelfLocation: event.target.getCenter(),
                          });
                        }}
                      >
                        <div className={styles.searchBarOnMap}>
                          <div className={styles.searchBox}>
                            <div
                              id="search_neighborhood"
                              className={styles.searchBoxInput}
                            >
                              {isSearching && (
                                <span className={styles.loader}>
                                  {" "}
                                  <Loader scale={0.4} />
                                </span>
                              )}
                              <input
                                // id="search_neighborhood_input"
                                type="text"
                                placeholder="جستجوی محله ..."
                                onChange={this.changeInputValue}
                                value={inputValue}
                              />
                              {searchItems.length !== 0 && (
                                <ul>
                                  {searchItems !== 0 &&
                                    searchItems.map((city) => (
                                      <li
                                        value={city.address}
                                        onClick={this.goSearchedCitySelf(city)}
                                      >
                                        {" "}
                                        {city.title}{" "}
                                        <span className={styles.cityReg}>
                                          ( {city.region} )
                                        </span>{" "}
                                      </li>
                                    ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className={styles.bottomBar}>
                          <div
                            className={styles.backBtn}
                            onClick={() => {
                              this.setState({ activeLocationType: 0 });
                              this.hideImber(0);
                            }}
                          >
                            <i
                              className="fa fa-arrow-right"
                              aria-hidden="true"
                              style={{ marginLeft: "5px" }}
                            >
                              {" "}
                            </i>
                            بازگشت
                          </div>
                          <div
                            className={styles.nextBtn}
                            onClick={this.returnLocation()}
                          >
                            قدم بعدی
                            <i
                              className="fa fa-arrow-left"
                              aria-hidden="true"
                              style={{ marginRight: "5px" }}
                            >
                              {" "}
                            </i>
                          </div>
                        </div>
                        <TileLayer url="https://map.kadro.co/styles/osm-bright/512/{z}/{x}/{y}.png" />
                        <Markers
                          data={[modifiedSelfLocation]}
                          isPopUp={false}
                          iconType={onDraging ? PinIconActive : PinIcon}
                        />
                      </Map>
                    )}
                  {Object.keys(sphotographer)?.length !== 0 &&
                    sphotographer.has_studio &&
                    activeCities?.activeCities?.length !== 0 &&
                    activeLocationType === 2 && (
                      <Map
                        style={{
                          width: "100%",
                          height: `${this.state.mapHeight}px`,
                        }}
                        center={
                          project?.data?.direct_photographer
                            ? {
                                lat: sphotographer?.studio_lat,
                                lng: sphotographer?.studio_lng,
                              }
                            : centerMap
                        }
                        zoom={11}
                        ondrag={(event) => {
                          this.setState({
                            centerMap: event.target.getCenter(),
                          });
                        }}
                        maxZoom={11}
                        minZoom={11}
                        zoomControl={false}
                        dragging={!sphotographer?.has_studio}
                      >
                        <div className={styles.bottomBar}>
                          <div
                            className={styles.backBtn}
                            onClick={() => {
                              this.setState({ activeLocationType: 0 });
                              this.hideImber(0);
                            }}
                          >
                            <i
                              className="fa fa-arrow-right"
                              aria-hidden="true"
                              style={{ marginLeft: "5px" }}
                            >
                              {" "}
                            </i>
                            بازگشت
                          </div>
                          <div
                            className={styles.nextBtn}
                            onClick={this.returnLocation()}
                          >
                            قدم بعدی
                            <i
                              className="fa fa-arrow-left"
                              aria-hidden="true"
                              style={{ marginRight: "5px" }}
                            >
                              {" "}
                            </i>
                          </div>
                        </div>
                        <TileLayer url="https://map.kadro.co/styles/osm-bright/512/{z}/{x}/{y}.png" />
                        {/* {!project?.data?.direct_photographer &&
                                                <Markers
                                                    data={filtredMarkers}
                                                    isPopUp={false}
                                                    iconType={StudioIcon}
                                                />} */}
                        {/* {!project?.data?.direct_photographer &&
                                                <Markers
                                                    data={StudioOuts}
                                                    isPopUp={false}
                                                    iconType={StudioOutIcon}
                                                />} */}
                        {project?.data?.direct_photographer && (
                          <Markers
                            data={[
                              {
                                lat: sphotographer?.studio_lat,
                                lng: sphotographer?.studio_lng,
                              },
                            ]}
                            isPopUp={false}
                            iconType={StudioIcon}
                          />
                        )}
                        <Circle
                          // center={centerMap}
                          center={
                            project?.data?.direct_photographer
                              ? {
                                  lat: sphotographer?.studio_lat,
                                  lng: sphotographer?.studio_lng,
                                }
                              : centerMap
                          }
                          radius={5000}
                          color="blue"
                        />
                      </Map>
                    )}
                  {activeCities?.activeCities?.length !== 0 &&
                    activeLocationType === 3 && (
                      <Map
                        style={{
                          width: "100%",
                          height: `${this.state.mapHeight}px`,
                        }}
                        center={initialSuggestLocation}
                        zoom={zoom}
                        ondrag={(event) => {
                          // this.setState({ centerMap: event.target.getCenter() });
                          this.setState({
                            modifiedSuggestLocation: event.target.getCenter(),
                          });
                        }}
                        maxZoom={18}
                        onDragStart={() => {
                          this.setState({ onDraging: true });
                        }}
                        onDragEnd={() => {
                          this.setState({ onDraging: false });
                        }}
                        onZoom={(event) => {
                          this.setState({
                            modifiedSuggestLocation: event.target.getCenter(),
                          });
                        }}
                      >
                        <div className={styles.searchBarOnMap}>
                          <div className={styles.searchBox}>
                            <div
                              id="search_neighborhood"
                              className={styles.searchBoxInput}
                            >
                              {isSearching && (
                                <span className={styles.loader}>
                                  {" "}
                                  <Loader scale={0.4} />
                                </span>
                              )}
                              <input
                                // id="search_neighborhood_input"
                                type="text"
                                placeholder="جستجوی محله ..."
                                onChange={this.changeInputValue}
                                value={inputValue}
                              />
                              {searchItems.length !== 0 && (
                                <ul>
                                  {searchItems !== 0 &&
                                    searchItems.map((city) => (
                                      <li
                                        value={city.address}
                                        onClick={this.goSearchedCityLocations(
                                          city
                                        )}
                                      >
                                        {" "}
                                        {city.title}{" "}
                                        <span className={styles.cityReg}>
                                          ( {city.region} )
                                        </span>{" "}
                                      </li>
                                    ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className={styles.bottomBar}>
                          <div
                            className={styles.backBtn}
                            onClick={() => {
                              this.setState({ activeLocationType: 0 });
                              this.hideImber(0);
                            }}
                          >
                            <i
                              className="fa fa-arrow-right"
                              aria-hidden="true"
                              style={{ marginLeft: "5px" }}
                            >
                              {" "}
                            </i>
                            بازگشت
                          </div>
                        </div>
                        <TileLayer url="https://map.kadro.co/styles/osm-bright/512/{z}/{x}/{y}.png" />
                        <Markers
                          data={
                            shoot_locations.length !== 0
                              ? shoot_locations
                              : [
                                  {
                                    avatar: { thumb: "/", medium: "/" },
                                    detail: "",
                                    lat: "35.6995454251",
                                    lng: "51.395642622465",
                                    slug: "",
                                    title: "",
                                  },
                                ]
                          }
                          isPopUp
                          iconType={ParkIcon}
                        />
                      </Map>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.locations,
    change: state.change.change,
    activeCities: state.activeCities,
    locationsTypes: [
      {
        title: "در محل",
        id: 1,
        elemanId: "in_location",
      },
      {
        title: "آتلیه‌ها",
        id: 2,
        elemanId: "in_studio",
      },
      {
        title: "مکان پیشنهادی",
        id: 3,
        elemanId: "shoot_location_suggest",
      },
    ],
    project: state.project,
    sphotographer: state.sphotographer,
    activeLocationOptions: state.activeLocationOptions,
    mylocations: state.mylocations,
  };
};
export default connect(mapStateToProps, {
  getActiveLocationOptions,
  getActiveCities,
  getLocation,
  getPackages,
  putData,
  getData,
  changeData,
  unchangeData,
  getSinglePhotographer,
  getMylocations,
})(withRouter(MapView));
